import { translate as t } from '@thoughtspot/i18n';
import { Alert, BannerAlertType, } from '@thoughtspot/radiant-react/widgets/alert';
import { FormControl } from '@thoughtspot/radiant-react/widgets/form-control';
import { Input } from '@thoughtspot/radiant-react/widgets/input';
import { Modal, ModalSize, ModalType, } from '@thoughtspot/radiant-react/widgets/modal';
import _ from 'lodash';
import React, { useState } from 'react';
import { Vertical } from "../../../utils/layouts";
import { validateCustomChart, ValidationErrorKey } from './custom-chart.util';
const TEST_IDS = {
    FORM_MODAL: 'custom-chart-form-modal',
    FORM_NAME_INPUT: 'chart-form-name-input',
    FORM_SOURCEURL_INPUT: 'chart-form-sourceurl-input',
    FORM_CHART_APP_ACCESS_TOKEN: 'chart-form-chart-app-access-token-input',
    FORM_ICON_URL_INPUT: 'chart-form-iconurl-input',
    FORM_DESCRIPTION_INPUT: 'chart-form-description-input',
    FORM_AUTHOR_NAME_INPUT: 'chart-form-author-name-input',
    FORM_AUTHOR_EMAIL_INPUT: 'chart-form-author-email-input',
    FORM_AUTHOR_ORG_INPUT: 'chart-form-author-org-input',
};
const CustomChartAddUpdateFormComponent = (props) => {
    const { validationErrorMap, formRef } = props;
    return (React.createElement("form", { action: "" },
        React.createElement(FormControl, { label: t('customChart.form.name.label'), helpText: t('customChart.form.name.helpText'), hasError: !_.isNil(validationErrorMap[ValidationErrorKey.NAME]), errorMessage: validationErrorMap[ValidationErrorKey.NAME] },
            React.createElement(Input.Text, { value: formRef.current?.name, ariaLabel: "chart-name", "data-testid": TEST_IDS.FORM_NAME_INPUT, onChange: (e, value) => {
                    formRef.current.name = value;
                } })),
        React.createElement(FormControl, { label: t('customChart.form.description.label'), helpText: t('customChart.form.description.helpText') },
            React.createElement(Input.Text, { value: formRef.current?.description, ariaLabel: "chart-description", "data-testid": TEST_IDS.FORM_DESCRIPTION_INPUT, onChange: (e, value) => {
                    formRef.current.description = value;
                } })),
        React.createElement(FormControl, { label: t('customChart.form.sourceUrl.label'), helpText: t('customChart.form.sourceUrl.helpText'), hasError: !_.isNil(validationErrorMap[ValidationErrorKey.SOURCE_URL]), errorMessage: validationErrorMap[ValidationErrorKey.SOURCE_URL] },
            React.createElement(Input.Text, { value: formRef.current?.sourceUrl, ariaLabel: "chart-app-url", "data-testid": TEST_IDS.FORM_SOURCEURL_INPUT, onChange: (e, value) => {
                    formRef.current.sourceUrl = value;
                } })),
        React.createElement(FormControl, { label: t('customChart.form.chartAppAccessToken.label'), helpText: t('customChart.form.chartAppAccessToken.helpText'), hasError: !_.isNil(validationErrorMap[ValidationErrorKey.CHART_APP_ACCESS_TOKEN]), errorMessage: validationErrorMap[ValidationErrorKey.CHART_APP_ACCESS_TOKEN] },
            React.createElement(Input.Text, { value: formRef.current?.chartAppAccessToken, ariaLabel: "chart-app-accessToken", "data-testid": TEST_IDS.FORM_CHART_APP_ACCESS_TOKEN, onChange: (e, value) => {
                    formRef.current.chartAppAccessToken = value;
                } })),
        React.createElement(FormControl, { label: t('customChart.form.iconUrl.label'), helpText: t('customChart.form.iconUrl.helpText'), hasError: !_.isNil(validationErrorMap[ValidationErrorKey.ICON_URL]), errorMessage: validationErrorMap[ValidationErrorKey.ICON_URL] },
            React.createElement(Input.Text, { value: formRef.current?.iconUrl, ariaLabel: "chart-icon-url", "data-testid": TEST_IDS.FORM_ICON_URL_INPUT, onChange: (e, value) => {
                    formRef.current.iconUrl = value;
                } })),
        React.createElement(FormControl, { label: t('customChart.form.author.name.label') },
            React.createElement(Input.Text, { value: formRef.current?.author?.name, ariaLabel: "chart-author-name", "data-testid": TEST_IDS.FORM_AUTHOR_NAME_INPUT, onChange: (e, value) => {
                    if (_.isNil(formRef.current.author)) {
                        formRef.current.author = {};
                    }
                    formRef.current.author.name = value;
                } })),
        React.createElement(FormControl, { label: t('customChart.form.author.email.label') },
            React.createElement(Input.Text, { value: formRef.current?.author?.email, ariaLabel: "chart-author-email", "data-testid": TEST_IDS.FORM_AUTHOR_EMAIL_INPUT, onChange: (e, value) => {
                    if (_.isNil(formRef.current.author)) {
                        formRef.current.author = {};
                    }
                    formRef.current.author.email = value;
                } })),
        React.createElement(FormControl, { label: t('customChart.form.author.organisation.label') },
            React.createElement(Input.Text, { value: formRef.current?.author?.organisation, ariaLabel: "chart-author-organisation", "data-testid": TEST_IDS.FORM_AUTHOR_ORG_INPUT, onChange: (e, value) => {
                    if (_.isNil(formRef.current.author)) {
                        formRef.current.author = {};
                    }
                    formRef.current.author.organisation = value;
                } }))));
};
export const CustomChartFormModal = ({ isModalOpen, customChartToBeUpdated, closeModal, handleOperation, operationError, }) => {
    const [validationErrorMap, setValidationErrorMap] = useState({});
    const formStateRef = React.useRef();
    const onClickSubmitButton = React.useCallback(() => {
        const errorMap = validateCustomChart(formStateRef.current);
        setValidationErrorMap(errorMap);
        if (Object.keys(errorMap).length === 0) {
            handleOperation(formStateRef.current);
        }
    }, [handleOperation]);
    React.useEffect(() => {
        if (isModalOpen === false) {
            setValidationErrorMap({});
        }
        formStateRef.current =
            _.omit(customChartToBeUpdated, [
                'modified',
                'created',
                'modifiedBy',
                'modifiedByName',
                'orgIds',
            ]) ?? {};
    }, [customChartToBeUpdated, isModalOpen]);
    const modalTitle = _.isNil(customChartToBeUpdated)
        ? t('customChart.modal.label.addChart')
        : t('customChart.modal.label.updateChart');
    const modalConfirmButtonText = _.isNil(customChartToBeUpdated)
        ? t('customChart.modal.confirmButton.addChart')
        : t('customChart.modal.confirmButton.updateChart');
    return (React.createElement(Modal, { title: modalTitle, variant: ModalType.Wizard, isOpen: isModalOpen, size: ModalSize.MEDIUM, doNotDismissOnOutsideClickOrEsc: true, dismissButton: {
            text: t('customChart.modal.dismissButton'),
            onClick: () => closeModal(),
        }, confirmButton: {
            text: modalConfirmButtonText,
            onConfirm: () => {
                onClickSubmitButton();
            },
        }, modalTestId: TEST_IDS.FORM_MODAL },
        React.createElement(Vertical, { grow: true, shrink: true },
            React.createElement(Alert.Banner, { isVisible: !_.isNil(operationError), message: `Unable to perform action: ${operationError?.message}`, type: BannerAlertType.ERROR, showCloseButton: false }),
            React.createElement(CustomChartAddUpdateFormComponent, { formRef: formStateRef, validationErrorMap: validationErrorMap }))));
};
export const testHooks = {
    CustomChartAddUpdateFormComponent,
    TEST_IDS,
};
//# sourceMappingURL=custom-chart-form.component.js.map